module.exports = __webpack_public_path__ + "img/s7.96994d58.png";